// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"60":"58586dd8","140":"2b6ec5e7","325":"da484562","773":"2795381f"}[chunkId] + ".css";
};